module.exports = __webpack_public_path__ + "static/media/m-tvshows.a48510cf.svg";